import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Button from './Button';
import uploadIcon from '@/assets/add.svg';
import previewIcon from '@/assets/visible.svg';
import deleteIcon from '@/assets/delete.svg';
import addIcon from '@/assets/card_more.svg';

const ImageUpload = ({
  label,
  onUpload,
  onDelete,
  onPreview,
  imageUrl,
  placeholderImage,
  className
}) => {
  const { t } = useTranslation();
  const [isHovered, setIsHovered] = useState(false);


  if (!imageUrl) {
    return (
      <div 
        className="aspect-[1] bg-[#f8f8f8] rounded-md border border-[#dddddd] relative flex justify-center items-center"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {!isHovered ? (
          <>
            <img 
                src={placeholderImage || addIcon} 
                className='mb-2'
            />
            <div className="absolute bottom-2 left-1/2 -translate-x-1/2 px-2 py-0.5 rounded-2xl">
                <div className="text-center text-[#666666] text-xs font-medium leading-[18px]">
                    {label}
                </div>
            </div>
          </>
        ) : (
          <Button
            variant="primary"
            size="m"
            onClick={onUpload}
          >
            <img src={uploadIcon} alt="upload" className="w-4 h-4" />
            {t('sell.product_info.upload')}
          </Button>
        )}
      </div>
    );
  }

  return (
    <div 
      className="aspect-[1] rounded-md border border-[#dddddd] relative overflow-hidden"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <img 
        src={imageUrl} 
        alt={label}
        className="w-full h-full object-contain"
      />
      
      {!isHovered ? (
        <div className="absolute bottom-2 left-1/2 -translate-x-1/2 px-2 py-0.5 bg-black/60 rounded-2xl backdrop-blur-sm">
          <div className="text-center text-white text-xs font-normal leading-[18px]">
            {label}
          </div>
        </div>
      ) : (
        <div className="absolute inset-0 bg-black/60 backdrop-blur-sm flex flex-col items-center justify-center gap-4">
          <Button
            variant="default"
            size="s"
            onClick={onPreview}
          >
            <img src={previewIcon} alt="preview" className="w-3.5 h-3.5" />
            {t('sell.product_info.preview')}
          </Button>
          <Button
            variant="primary"
            size="s"
            className="bg-[#ff2b00] hover:bg-[#ff5938]"
            onClick={onDelete}
          >
            <img src={deleteIcon} alt="delete" className="w-3.5 h-3.5" />
            {t('sell.product_info.delete')}
          </Button>
        </div>
      )}
    </div>
  );
};

export default ImageUpload; 